module.exports = __webpack_public_path__ + "static/media/HealthActive.7fa668fa.svg";